"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useState, type MouseEvent } from "react";
import MediaDisplay from "@/components/drops/view/item/content/media/MediaDisplay";
import { useLinkPreviewVariant, type LinkPreviewVariant } from "./LinkPreviewContext";
import { LinkPreviewCardLayout } from "./OpenGraphPreview";
import { removeBaseEndpoint } from "@/helpers/Helpers";
interface ManifoldItemPreviewCardProps {
  readonly href: string;
  readonly title: string;
  readonly mediaUrl: string;
  readonly mediaMimeType: string;
  readonly imageOnly?: boolean | undefined;
  readonly hideActions?: boolean | undefined;
}
function getContainerClass(variant: LinkPreviewVariant, imageOnly: boolean): string {
  if (imageOnly) {
    if (variant === "home") {
      return "tw-w-full tw-overflow-hidden tw-rounded-xl tw-bg-black/30";
    }
    return "tw-w-full tw-overflow-hidden tw-rounded-xl tw-bg-iron-900/40";
  }
  if (variant === "home") {
    return "tw-w-full tw-overflow-hidden tw-rounded-xl tw-bg-iron-950/50";
  }
  return "tw-w-full tw-overflow-hidden tw-bg-inherit";
}
function getTitleRowClass(variant: LinkPreviewVariant): string {
  if (variant === "home") {
    return "tw-bg-iron-950/50 tw-px-3 tw-py-2";
  }
  return "tw-py-1.5";
}
function OverlayActionButtons(t0) {
  const $ = _c(17);
  const {
    href
  } = t0;
  const [copied, setCopied] = useState(false);
  let t1;
  if ($[0] !== href) {
    const relative = removeBaseEndpoint(href);
    t1 = typeof relative === "string" && relative.startsWith("/") ? relative : undefined;
    $[0] = href;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const relativeHref = t1;
  const stop = _temp;
  let t2;
  if ($[2] !== href) {
    t2 = e_0 => {
      stop(e_0);
      navigator.clipboard.writeText(href).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 500);
      }).catch(_temp2);
    };
    $[2] = href;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const copyToClipboard = t2;
  const t3 = copied ? "#34d399" : "currentColor";
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <svg className="tw-size-3.5 tw-flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke={t3}>{t4}</svg>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== copyToClipboard || $[8] !== t5) {
    t6 = <button type="button" className="tw-flex tw-size-8 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-transparent tw-text-white tw-backdrop-blur-md tw-transition-colors tw-duration-150" onClick={copyToClipboard} onMouseDown={_temp3}>{t5}</button>;
    $[7] = copyToClipboard;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = relativeHref ?? href;
  const t8 = relativeHref ? undefined : "_blank";
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <svg className="tw-size-3.5 tw-flex-shrink-0" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" strokeWidth="3" stroke="currentColor" fill="none"><path d="M55.4,32V53.58a1.81,1.81,0,0,1-1.82,1.82H10.42A1.81,1.81,0,0,1,8.6,53.58V10.42A1.81,1.81,0,0,1,10.42,8.6H32" /><polyline points="40.32 8.6 55.4 8.6 55.4 24.18" /><line x1="19.32" y1="45.72" x2="54.61" y2="8.91" /></svg>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t7 || $[12] !== t8) {
    t10 = <Link href={t7} target={t8} className="tw-flex tw-size-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-transparent tw-text-white tw-no-underline tw-backdrop-blur-md tw-transition-colors tw-duration-150" onClick={_temp4} onMouseDown={_temp5}>{t9}</Link>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t6) {
    t11 = <div className="tw-absolute tw-right-3 tw-top-3 tw-z-10 tw-flex tw-flex-col tw-gap-2">{t6}{t10}</div>;
    $[14] = t10;
    $[15] = t6;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}
function _temp5(e_3) {
  return e_3.stopPropagation();
}
function _temp4(e_2) {
  return e_2.stopPropagation();
}
function _temp3(e_1) {
  return e_1.stopPropagation();
}
function _temp2() {}
function _temp(e) {
  e.stopPropagation();
  e.preventDefault();
}
export default function ManifoldItemPreviewCard(t0) {
  const $ = _c(25);
  const {
    href,
    title,
    mediaUrl,
    mediaMimeType,
    imageOnly: t1,
    hideActions: t2
  } = t0;
  const imageOnly = t1 === undefined ? false : t1;
  const hideActions = t2 === undefined ? false : t2;
  const variant = useLinkPreviewVariant();
  let t3;
  if ($[0] !== imageOnly || $[1] !== variant) {
    t3 = getContainerClass(variant, imageOnly);
    $[0] = imageOnly;
    $[1] = variant;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `${t3} tw-relative`;
  let t5;
  if ($[3] !== mediaMimeType || $[4] !== mediaUrl) {
    t5 = <div className="tw-aspect-[16/9] tw-min-h-[14rem] tw-w-full tw-bg-inherit md:tw-min-h-[15rem]" data-testid="manifold-item-media"><MediaDisplay media_mime_type={mediaMimeType} media_url={mediaUrl} disableMediaInteraction={true} /></div>;
    $[3] = mediaMimeType;
    $[4] = mediaUrl;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== imageOnly || $[7] !== title || $[8] !== variant) {
    t6 = !imageOnly && <div className={getTitleRowClass(variant)}><h3 className="tw-mb-0 tw-truncate tw-text-sm tw-font-bold tw-leading-tight tw-text-iron-200" data-testid="manifold-item-title">{title}</h3></div>;
    $[6] = imageOnly;
    $[7] = title;
    $[8] = variant;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== href || $[11] !== t5 || $[12] !== t6) {
    t7 = <Link href={href} target="_blank" rel="noopener noreferrer" prefetch={false} className="tw-flex tw-w-full tw-flex-col tw-overflow-hidden tw-no-underline">{t5}{t6}</Link>;
    $[10] = href;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== hideActions || $[15] !== href) {
    t8 = !hideActions && <OverlayActionButtons href={href} />;
    $[14] = hideActions;
    $[15] = href;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t7 || $[19] !== t8) {
    t9 = <div className={t4} data-testid="manifold-item-card">{t7}{t8}</div>;
    $[17] = t4;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== href || $[22] !== t9 || $[23] !== variant) {
    t10 = <LinkPreviewCardLayout href={href} variant={variant} hideActions={true}>{t9}</LinkPreviewCardLayout>;
    $[21] = href;
    $[22] = t9;
    $[23] = variant;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}